module.exports = __webpack_public_path__ + "img/target.4b4f9b11.svg";